<script lang="ts">
import { PropType } from "vue"
import { AlarmLevel } from "@/types/alarm"
import { alarmLevelLabel, levelVariant } from "@/utils/alarm-utils"

export default {
    name: "AlarmLevelBadge",
    props: {
        level: {
            type: String as PropType<AlarmLevel>,
            required: true,
        },
        active: {
            type: Boolean,
            default: false,
        },
        interactive: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        variant(): string {
            return levelVariant(this.level)
        },
        label(): string {
            return alarmLevelLabel(this.$i18n, this.level)
        },
    },
    methods: {
        handleClick() {
            if (this.interactive) {
                this.$emit("click")
            }
        },
    },
}
</script>

<template>
    <component
        :is="interactive ? 'button' : 'span'"
        :type="interactive ? 'button' : undefined"
        class="alarm-level-badge"
        :class="[
            `alarm-level-badge--${variant}`,
            {
                'alarm-level-badge--active': active,
                'alarm-level-badge--interactive': interactive,
            },
        ]"
        @click="handleClick"
    >
        {{ label }}
    </component>
</template>

<style lang="scss" scoped>
.alarm-level-badge {
    display: inline-flex;
    align-items: center;
    padding: 0.25rem 0.75rem;
    font-weight: 700;
    font-size: 0.8rem;
    background: none;
    border-radius: 0.5rem;

    &--interactive {
        cursor: pointer;
    }

    &--danger {
        color: var(--toast-danger-accent);
        border: 1px solid var(--toast-danger-accent);
    }
    &--warning {
        color: var(--toast-warning-accent);
        border: 1px solid var(--toast-warning-accent);
    }
    &--info {
        color: var(--toast-info-accent);
        border: 1px solid var(--toast-info-accent);
    }
    &--secondary {
        color: var(--theme-auxiliary);
        border: 1px solid var(--theme-secondary-transparent-50);
    }

    &--active.alarm-level-badge--danger {
        background-color: color-mix(in srgb, var(--toast-danger-accent) 15%, transparent);
    }
    &--active.alarm-level-badge--warning {
        background-color: color-mix(in srgb, var(--toast-warning-accent) 15%, transparent);
    }
    &--active.alarm-level-badge--info {
        background-color: color-mix(in srgb, var(--toast-info-accent) 15%, transparent);
    }
    &--active.alarm-level-badge--secondary {
        background-color: var(--theme-tertiary-25);
    }
}
</style>
